import blogimg from "../images/blog.png"
import startupimg from "../images/kilimoshare.png"
import qsimg from "../images/qsapp.png"

const data = {
    "properties": [
        {
            "index":0,
            "picture":blogimg,
            "alt": "blog-website",
            "link":"http://bmsteven-com.stackstaging.com",
            "code":"https://www.github.com/bmsteven/blog",
            "title":"Personal blog"
        },
        {
            "index":1,
            "picture": startupimg,
            "alt": "startup website",
            "link":"http://www.kilimoshare.com",
            "code":"#",
            "title": "Startup website"
        },
        {
            "index":2,
            "picture":qsimg,
            "alt":"quantity-survey-app",
            "link":"https://bmsteven.github.io/portfolio/projects/qsapp/",
            "code":"#",
            "title":"Quantity survey app"
        }
    ]
}

export default data;